export const OHL = {
    name: 'DV 1165 RP ĐERDAP 2 - TS NEGOTIN',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 2', position: {lat: 44.2983, lng: 22.565}}],
    stubovi: [
        { index: 1, name: 'P-08', lat: 44.2978 , lng: 22.5651, sys: 1, portal: true},
        { index: 2, name: '1', lat: 44.2975 , lng: 22.5651, sys: 1},
        { index: 3, name: '2', lat: 44.2952 , lng: 22.5641, sys: 1},
        { index: 4, name: '3', lat: 44.2929 , lng: 22.5622, sys: 1},
        { index: 5, name: '4', lat: 44.2906 , lng: 22.5604, sys: 1},
        { index: 6, name: '5', lat: 44.2896 , lng: 22.557, sys: 1},
        { index: 7, name: '6', lat: 44.2887 , lng: 22.5538, sys: 1},
        { index: 8, name: '7', lat: 44.288 , lng: 22.5513, sys: 1},
        { index: 9, name: '8', lat: 44.2872 , lng: 22.5484, sys: 1},
        { index: 10, name: '9', lat: 44.2851 , lng: 22.5474, sys: 1},
        { index: 11, name: '10', lat: 44.2829 , lng: 22.5463, sys: 1},
        { index: 12, name: '11', lat: 44.2805 , lng: 22.5451, sys: 1},
        { index: 13, name: '12', lat: 44.2784 , lng: 22.5441, sys: 1},
        { index: 14, name: '13', lat: 44.2761 , lng: 22.543, sys: 1},
        { index: 15, name: '14', lat: 44.2737 , lng: 22.5418, sys: 1},
        { index: 16, name: '15', lat: 44.2712 , lng: 22.5406, sys: 1},
        { index: 17, name: '16', lat: 44.2685 , lng: 22.5393, sys: 1},
        { index: 18, name: '17', lat: 44.2663 , lng: 22.5382, sys: 1},
        { index: 19, name: '18', lat: 44.2643 , lng: 22.5372, sys: 1},
        { index: 20, name: '19', lat: 44.2626 , lng: 22.5381, sys: 1},
        { index: 21, name: '20', lat: 44.2609 , lng: 22.5389, sys: 1},
        { index: 22, name: '21', lat: 44.2586 , lng: 22.54, sys: 1},
        { index: 23, name: '22', lat: 44.2558 , lng: 22.5414, sys: 1},
        { index: 24, name: '23', lat: 44.2531 , lng: 22.5427, sys: 1},
        { index: 25, name: '24', lat: 44.251 , lng: 22.5434, sys: 1},
        { index: 26, name: '25', lat: 44.2489 , lng: 22.5425, sys: 1},
        { index: 27, name: 'P-07', lat: 44.2481 , lng: 22.542, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-08 - 1', position: [{ lat: 44.2978 , lng: 22.5651 }, { lat: 44.2975 , lng: 22.5651 }] },
        { name: '1 - 2', position: [{ lat: 44.2975 , lng: 22.5651 }, { lat: 44.2952 , lng: 22.5641 }] },
        { name: '2 - 3', position: [{ lat: 44.2952 , lng: 22.5641 }, { lat: 44.2929 , lng: 22.5622 }] },
        { name: '3 - 4', position: [{ lat: 44.2929 , lng: 22.5622 }, { lat: 44.2906 , lng: 22.5604 }] },
        { name: '4 - 5', position: [{ lat: 44.2906 , lng: 22.5604 }, { lat: 44.2896 , lng: 22.557 }] },
        { name: '5 - 6', position: [{ lat: 44.2896 , lng: 22.557 }, { lat: 44.2887 , lng: 22.5538 }] },
        { name: '6 - 7', position: [{ lat: 44.2887 , lng: 22.5538 }, { lat: 44.288 , lng: 22.5513 }] },
        { name: '7 - 8', position: [{ lat: 44.288 , lng: 22.5513 }, { lat: 44.2872 , lng: 22.5484 }] },
        { name: '8 - 9', position: [{ lat: 44.2872 , lng: 22.5484 }, { lat: 44.2851 , lng: 22.5474 }] },
        { name: '9 - 10', position: [{ lat: 44.2851 , lng: 22.5474 }, { lat: 44.2829 , lng: 22.5463 }] },
        { name: '10 - 11', position: [{ lat: 44.2829 , lng: 22.5463 }, { lat: 44.2805 , lng: 22.5451 }] },
        { name: '11 - 12', position: [{ lat: 44.2805 , lng: 22.5451 }, { lat: 44.2784 , lng: 22.5441 }] },
        { name: '12 - 13', position: [{ lat: 44.2784 , lng: 22.5441 }, { lat: 44.2761 , lng: 22.543 }] },
        { name: '13 - 14', position: [{ lat: 44.2761 , lng: 22.543 }, { lat: 44.2737 , lng: 22.5418 }] },
        { name: '14 - 15', position: [{ lat: 44.2737 , lng: 22.5418 }, { lat: 44.2712 , lng: 22.5406 }] },
        { name: '15 - 16', position: [{ lat: 44.2712 , lng: 22.5406 }, { lat: 44.2685 , lng: 22.5393 }] },
        { name: '16 - 17', position: [{ lat: 44.2685 , lng: 22.5393 }, { lat: 44.2663 , lng: 22.5382 }] },
        { name: '17 - 18', position: [{ lat: 44.2663 , lng: 22.5382 }, { lat: 44.2643 , lng: 22.5372 }] },
        { name: '18 - 19', position: [{ lat: 44.2643 , lng: 22.5372 }, { lat: 44.2626 , lng: 22.5381 }] },
        { name: '19 - 20', position: [{ lat: 44.2626 , lng: 22.5381 }, { lat: 44.2609 , lng: 22.5389 }] },
        { name: '20 - 21', position: [{ lat: 44.2609 , lng: 22.5389 }, { lat: 44.2586 , lng: 22.54 }] },
        { name: '21 - 22', position: [{ lat: 44.2586 , lng: 22.54 }, { lat: 44.2558 , lng: 22.5414 }] },
        { name: '22 - 23', position: [{ lat: 44.2558 , lng: 22.5414 }, { lat: 44.2531 , lng: 22.5427 }] },
        { name: '23 - 24', position: [{ lat: 44.2531 , lng: 22.5427 }, { lat: 44.251 , lng: 22.5434 }] },
        { name: '24 - 25', position: [{ lat: 44.251 , lng: 22.5434 }, { lat: 44.2489 , lng: 22.5425 }] },
        { name: '25 - P-07', position: [{ lat: 44.2489 , lng: 22.5425 }, { lat: 44.2481 , lng: 22.542 }] }

  
    ]
}
